import { render, staticRenderFns } from "./ReportReceiveParcelsOnBranchFee.vue?vue&type=template&id=0fa2afa2&"
import script from "./ReportReceiveParcelsOnBranchFee.vue?vue&type=script&lang=js&"
export * from "./ReportReceiveParcelsOnBranchFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports